module.exports = __webpack_public_path__ + "img/68.902550a8.jpg";